import Vue from "vue";
import axios, { CancelToken } from "axios";
import store from "../store/index";
import {getBase64CryptText} from "./common-util";
import moment from 'moment';
import lodash from 'lodash'
import router from "@/router";

console.log("### API URL ", process.env.VUE_APP_EXT_API);

const service = axios.create({
    baseURL: process.env.VUE_APP_EXT_API, // url = base url + request url
    //withCredentials: true, // send cookies when cross-domain requests
    timeout: 300000,
});

//header에 token값 셋팅 제외할 url
const excludePath = [
    '/api/sso/token/create',  // site token 발급
    '/api/sso/ssoAdm/login',  // login
]



// request interceptor
service.interceptors.request.use(

    config => {

        let timestamp = moment().format('YYYYMMDDHHmmssSSS'); // yyyyMMddHHmmssSSS

        // 토큰 추가
        // @ts-ignore
        if(store.state.sso.adm.accessToken && !lodash.includes(excludePath,config.url)){ //
            // @ts-ignore
            let accessToken = store.state.sso.adm.accessToken;
            let encToken = getBase64CryptText(accessToken,timestamp.toString());

            config.headers.Authorization = 'bearer '+encToken;  // 암호화 토큰
            config.headers.timestamp = timestamp;
        }
        console.log('########################################');
        console.log('## url:',config.url);
        console.log('## method:',config.method);
        console.log('## params:',config.params);

        return config;
    },
    error => {
        // do something with request error

        console.log("error ---------- ", error); // for debug

        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(

    async (response) => {

        const res = response.data;
        const { config } = response;

        console.log('## result:',res);
        console.log('########################################');
        return res;
        /*

        //console.log('@@@@@@@@ response res.dataHeader ',res.dataHeader)

        // 데이터 타입이 zip인 경우 유효성 처리 무시하기
        if (res.type == "application/zip") {
            return res;
        }

        // 데이터 타입이 json 파일인 경우 유효성 처리 무시하기
        if (res.type == "application/json") {
            return res;
        }
        //토큰 만료시*/


    },
    error => {

        //예외 에러 처리
        // 서버 요청을 취소한 경우 또는 네트워크 에러인 경우 
        if (error.response) {
            console.error('## error:',error.response);
            let res = error.response.data
            router.push("/sso/login")
            return Promise.reject(error);
        }else{
            console.log('## network error',error)
            return Promise.reject(error);
        }

        // all the other error responses
        /*switch (error.response.status) {

            case 401: // authentication error, logout the user
                let res = error.response.data
                console.error(error.response.status, res.message);
                router.push("/sso/login")
                break;

            default:
                console.error(error.response.status, error.message);
            //notify.error('Server Error');
        }*/
        // axios에서 서버 요청을 취소한 경우에 실행.
        if (axios.isCancel(error)) {
            return Promise.reject(error);
        }

        return Promise.reject(error);
    }
);

export { CancelToken };
export default service;
